import { render, staticRenderFns } from "./combo-card.vue?vue&type=template&id=22f03a92&scoped=true"
import script from "./combo-card.vue?vue&type=script&lang=js"
export * from "./combo-card.vue?vue&type=script&lang=js"
import style0 from "./combo-card.vue?vue&type=style&index=0&id=22f03a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f03a92",
  null
  
)

export default component.exports